import { scenes } from "../scenes";
import { Scene, Choice, Dialog } from "../models";

export class BankInterior extends Scene {
  async init() {
    this.title = "Inside the Bank";
    this.image = require("@/images/ATM.png");
    this.audio = null;
    this.showInput = false;
    this.description = "";
    if (this.state.storylines.fenceOpened) {
      this.state.storylines.findAtm = false
      this.state.storylines.atmFound = true
    }
  }

  get options(): any[] {
    const options = [
      new Choice("Read Sign", () => {
        this.description =
          "SONNY YANG: The sign reads: “Note to our valued customers: We recognise that the YOGID-19 epidemic has created unprecedented economic hardships for many of you and that these are desperate times in which we find ourselves. In response, your faithful Bank has hired armed mercenaries to dispense swift capitalist justice to anyone caught tampering with our ATMs.";
        this.audio = require("@/audio/Pandemic-83-Sonny-MP3.mp3");
      }),
    ];

    if (!this.state.inventory.creditCard.has) {
      options.push(
        new Choice("Use ATM", async () => await this.navigate(scenes.ATM())
        ))
    } else {
      options.push(
        new Choice("Use ATM", () => {
          this.description =
            "SONNY YANG: I have no further need for the automated teller machine.";
          this.audio = require("@/audio/Pandemic-87-Sonny-MP3.mp3");
        })
      );
    }

    options.push(new Choice("Leave the bank ", async () => {
      await this.navigate(scenes.BankExterior());
    }))

    return options;
  }
}

export default new BankInterior();
